import {Mutator} from 'final-form';
import {merge} from 'lodash';
import sanitizeErrors from './sanitizeErrors';
import * as dotObject from 'dot-object';

const setErrors: Mutator = ([errors, override = false], state) => {
  const sanitizedErrors = sanitizeErrors(errors ?? {});
  const submitErrors = dotObject.object(sanitizedErrors);

  if (override) {
    state.formState.submitErrors = submitErrors;
  } else {
    state.formState.submitErrors = merge(state.formState.submitErrors ?? {}, submitErrors);
  }

  state.lastFormState.hasSubmitErrors = true;
  state.formState.submitFailed = true;
  state.formState.submitSucceeded = false;
  state.formState.lastSubmittedValues = state.formState.values;
}

export default setErrors;
